import { Box, Flex, Image, Text, useColorModeValue } from '@chakra-ui/react';
import NumberFlow from '@number-flow/react';
import { useMemo } from 'react';
import { CgChevronUp } from 'react-icons/cg';

import type { Price } from 'types/api/websiteApi/price';

interface Props {
  data?: Price;
}

export const LatestPriceContent = ({ data }: Props) => {
  const isPositive = useMemo(
    () => Number(data?.percent_change_24h) > 0,
    [ data?.percent_change_24h ],
  );

  const upArrowBg = useColorModeValue('green.200', 'green.200');
  const downArrowBg = useColorModeValue('orange.500', 'orange.500');
  const upTextColor = useColorModeValue('green.200', 'green.200');
  const downTextColor = useColorModeValue('orange.500', 'orange.500');

  return (
    <Flex alignItems="center" gap={{ base: '6px', sm: '12px' }}>
      <Flex alignItems="center" gap={{ base: '2px', sm: '12px' }}>
        <Box position="relative" width="24px" height="24px">
          <Image
            alt="Status Logo"
            src="/static/tao-currency-logo.png"
          />
        </Box>
        <Text fontWeight="500" fontSize="sm" color="white">
          $
          <NumberFlow
            format={{
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            }}
            value={ Number(data?.price) }
          />
        </Text>
      </Flex>

      <Flex alignItems="center" gap={{ base: '2px', sm: '6px' }}>
        <Box
          as={ CgChevronUp }
          transform={ isPositive ? 'none' : 'rotate(180deg)' }
          bg={ isPositive ? upArrowBg : downArrowBg }
          color="black"
          size="12px"
        />
        <Text
          fontSize="xs"
          color={ isPositive ? upTextColor : downTextColor }
        >
          <NumberFlow
            format={{
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            }}
            suffix="%"
            value={ Number(data?.percent_change_24h) }
          />
        </Text>
      </Flex>
    </Flex>
  );
};
